export default "__VITE_ASSET__BpOlp8Oq__"